export default {
    main: {
        title: 'AI产品&解决方案',
        bannertitle:'光伏组件智能制造专家',
        serviceslist: [
            {
                name: '提升组件生产数据化',
                detail: '以人工智能、工业互联网、大数据等新兴技术为依托的智能制造与光伏行业的结合时机已经成熟。'
            },
            {
                name: '生产效率及品质双提升',
                detail: '通过系统可以得到更合理的长效解决方案，优化工作效率、精简人力、提升品质。'
            },
            {
                name: '杜绝批量缺陷产生',
                detail: '将生产更加依托于智能化的流水线工艺，并在质量把控上，也从检验阶段逐步发展全面质量管理阶段。'
            },
            {
                name: '优化生产资源配置',
                detail: '通过全流程的检测信息高度集成化和数据可视化，实现生产过程的信息采集。'
            },
            {
                name: '卡控重要缺陷传递',
                detail: '结合工艺经验和图像大数据算法，自动实时且智能化的平台可以取代工艺繁琐的分析数据和定位设备故障的全过程。'
            },
            {
                name: '全面科技显能',
                detail: '随着光伏制造自动化程度不断提高，智能化已成为各大工厂的首要目标，目前，市场上大部分已转化70%-80%。'
            }

        ],
        maodianlist: [
            {
                name: '首页',
                detail: 'body'

            },
            {
                name: '服务',
                detail: 'services'
            },
            {
                name: '产品',
                detail: 'products'
            },
            {
                name: '合作',
                detail: 'work'
            },
            {
                name: '联系我们',
                detail: 'contact'
            }
        ],
    }
}